{
  "name": "@aws-sdk/client-cognito-identity",
  "description": "AWS SDK for JavaScript Cognito Identity Client for Node.js, Browser and React Native",
  "version": "3.588.0",
  "scripts": {
    "build": "concurrently 'yarn:build:cjs' 'yarn:build:es' 'yarn:build:types'",
    "build:cjs": "node ../../scripts/compilation/inline client-cognito-identity",
    "build:es": "tsc -p tsconfig.es.json",
    "build:include:deps": "lerna run --scope $npm_package_name --include-dependencies build",
    "build:types": "tsc -p tsconfig.types.json",
    "build:types:downlevel": "downlevel-dts dist-types dist-types/ts3.4",
    "clean": "rimraf ./dist-* && rimraf *.tsbuildinfo",
    "extract:docs": "api-extractor run --local",
    "generate:client": "node ../../scripts/generate-clients/single-service --solo cognito-identity",
    "test:e2e": "ts-mocha test/**/*.ispec.ts && karma start karma.conf.js"
  },
  "main": "./dist-cjs/index.js",
  "types": "./dist-types/index.d.ts",
  "module": "./dist-es/index.js",
  "sideEffects": false,
  "dependencies": {
    "@aws-crypto/sha256-browser": "3.0.0",
    "@aws-crypto/sha256-js": "3.0.0",
    "@aws-sdk/client-sso-oidc": "3.588.0",
    "@aws-sdk/client-sts": "3.588.0",
    "@aws-sdk/core": "3.588.0",
    "@aws-sdk/credential-provider-node": "3.588.0",
    "@aws-sdk/middleware-host-header": "3.577.0",
    "@aws-sdk/middleware-logger": "3.577.0",
    "@aws-sdk/middleware-recursion-detection": "3.577.0",
    "@aws-sdk/middleware-user-agent": "3.587.0",
    "@aws-sdk/region-config-resolver": "3.587.0",
    "@aws-sdk/types": "3.577.0",
    "@aws-sdk/util-endpoints": "3.587.0",
    "@aws-sdk/util-user-agent-browser": "3.577.0",
    "@aws-sdk/util-user-agent-node": "3.587.0",
    "@smithy/config-resolver": "^3.0.1",
    "@smithy/core": "^2.1.1",
    "@smithy/fetch-http-handler": "^3.0.1",
    "@smithy/hash-node": "^3.0.0",
    "@smithy/invalid-dependency": "^3.0.0",
    "@smithy/middleware-content-length": "^3.0.0",
    "@smithy/middleware-endpoint": "^3.0.1",
    "@smithy/middleware-retry": "^3.0.3",
    "@smithy/middleware-serde": "^3.0.0",
    "@smithy/middleware-stack": "^3.0.0",
    "@smithy/node-config-provider": "^3.1.0",
    "@smithy/node-http-handler": "^3.0.0",
    "@smithy/protocol-http": "^4.0.0",
    "@smithy/smithy-client": "^3.1.1",
    "@smithy/types": "^3.0.0",
    "@smithy/url-parser": "^3.0.0",
    "@smithy/util-base64": "^3.0.0",
    "@smithy/util-body-length-browser": "^3.0.0",
    "@smithy/util-body-length-node": "^3.0.0",
    "@smithy/util-defaults-mode-browser": "^3.0.3",
    "@smithy/util-defaults-mode-node": "^3.0.3",
    "@smithy/util-endpoints": "^2.0.1",
    "@smithy/util-middleware": "^3.0.0",
    "@smithy/util-retry": "^3.0.0",
    "@smithy/util-utf8": "^3.0.0",
    "tslib": "^2.6.2"
  },
  "devDependencies": {
    "@aws-sdk/client-iam": "3.588.0",
    "@tsconfig/node16": "16.1.3",
    "@types/chai": "^4.2.11",
    "@types/mocha": "^8.0.4",
    "@types/node": "^16.18.96",
    "concurrently": "7.0.0",
    "downlevel-dts": "0.10.1",
    "rimraf": "3.0.2",
    "typescript": "~4.9.5"
  },
  "engines": {
    "node": ">=16.0.0"
  },
  "typesVersions": {
    "<4.0": {
      "dist-types/*": [
        "dist-types/ts3.4/*"
      ]
    }
  },
  "files": [
    "dist-*/**"
  ],
  "author": {
    "name": "AWS SDK for JavaScript Team",
    "url": "https://aws.amazon.com/javascript/"
  },
  "license": "Apache-2.0",
  "browser": {
    "./dist-es/runtimeConfig": "./dist-es/runtimeConfig.browser"
  },
  "react-native": {
    "./dist-es/runtimeConfig": "./dist-es/runtimeConfig.native"
  },
  "homepage": "https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-cognito-identity",
  "repository": {
    "type": "git",
    "url": "https://github.com/aws/aws-sdk-js-v3.git",
    "directory": "clients/client-cognito-identity"
  }
}
